import { Components, Theme } from '@mui/material/styles';
export const MuiSelect: Components<Theme>['MuiSelect'] = {
  styleOverrides: {
    select: {
      '&.MuiInputBase-inputSizeSmall': {
        padding: '6px 30px 6px 10px',
        fontSize: 13,
        lineHeight: '18px',
        minHeight: '18px',
      },
    },
  },
};
